export const CMS_SECTION_SLUGS = {
  hero: "hero_section",
  howitworks: "how_it_works",
  discoverascender: "discover_section",
  attractions: "attractions",
  ctabanner: "cta_section",
};

const appendFile = (formData, key, file) => {
  if (file instanceof File) {
    formData.append(key, file);
  }
};

export const buildHeroSectionFormData = ({
  heading,
  subHeading,
  button1Text,
  button2Text,
  heroStats,
  files,
}) => {
  const formData = new FormData();
  formData.append("heading", heading);
  formData.append("subHeading", subHeading);
  formData.append("button1Text", button1Text);
  formData.append("button2Text", button2Text);
  
  formData.append("distance", heroStats[0]?.value ?? "");
  formData.append("milestones", heroStats[0]?.label ?? "");
  formData.append("duration", heroStats[0]?.duration ?? "");
  
  appendFile(formData, "backgroundImage", files.backgroundImage);
  appendFile(formData, "characterImage", files.characterImage);
  return formData;
};

export const buildHowItWorksFormData = ({
  sectionHeading,
  sectionDescription,
  cards,
  cardFiles,
}) => {
  const formData = new FormData();
  formData.append("sectionHeading", sectionHeading);
  formData.append("sectionDescription", sectionDescription);

  cards.forEach((card, index) => {
    formData.append(`cards[${index}][title]`, card.heading);
    formData.append(`cards[${index}][description]`, card.paragraph);
    appendFile(formData, `cardImage${index}`, cardFiles[index]);
  });

  return formData;
};

export const buildAttractionsFormData = ({
  sectionTitle,
  sectionDescription,
  attractions,
  itemFiles,
}) => {
  const formData = new FormData();
  formData.append("sectionTitle", sectionTitle);
  formData.append("sectionDescription", sectionDescription);

  const items = attractions.map((item, index) => ({
    title: item.title?.trim() || `Attraction ${index + 1}`,
    displayOrder: index + 1,
    isActive: true,
  }));

  formData.append("items", JSON.stringify(items));

  attractions.forEach((_, index) => {
    appendFile(formData, `itemImage${index}`, itemFiles[index]);
  });

  return formData;
};

export const buildCtaSectionFormData = ({
  heading,
  subHeading,
  buttonText,
  files,
}) => {
  const formData = new FormData();
  formData.append("heading", heading);
  formData.append("subHeading", subHeading);
  formData.append("buttonText", buttonText);
  appendFile(formData, "topAvatarImage", files.topAvatarImage);
  appendFile(formData, "mapImage", files.mapImage);
  appendFile(formData, "bottomImage1", files.bottomImage1);
  appendFile(formData, "bottomImage2", files.bottomImage2);
  appendFile(formData, "bottomImage3", files.bottomImage3);
  return formData;
};
export const buildDiscoverSectionFormData = ({
  sectionTitle,
  discoverStats,
  files,
}) => {
  const formData = new FormData();
  formData.append("sectionTitle", sectionTitle);
  
  // Fix: Access the correct indices
  formData.append("totalKm", discoverStats[0]?.label || "");
  formData.append("activeUsers", discoverStats[0]?.value || "");
  formData.append("customerSatisfaction", discoverStats[1]?.value || "");
  
  appendFile(formData, "backgroundImage", files.backgroundImage);
  
  // Only append video if it exists (make it optional)
  if (files.video && files.video instanceof File) {
    appendFile(formData, "video", files.video);
  }
  
  return formData;
};

export const buildCmsFormData = (landingType, payload) => {
  switch (landingType) {
    case "hero":
      return buildHeroSectionFormData(payload);
    case "howitworks":
      return buildHowItWorksFormData(payload);
    case "attractions":
      return buildAttractionsFormData(payload);
    case "ctabanner":
      return buildCtaSectionFormData(payload);
    case "discoverascender":
      return buildDiscoverSectionFormData(payload);
    default:
      return null;
  }
};